const EXPIRATION_TIME = 7200000

export const calculateTokenExpirationTime = () => Date.now() + EXPIRATION_TIME